import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
 // createTheme,
} from "@mui/material";

interface UsrMenuProps {
  onLogoutFromMenu: () => void;  // Se recibe la función de logout como prop
  errorMessage:string;
  open:boolean
}

const DialogModal: React.FC<UsrMenuProps> = ({ open,onLogoutFromMenu,errorMessage }) => {
  //const theme = createTheme();


  return (
<Dialog open={open} onClose={onLogoutFromMenu}>
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{errorMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onLogoutFromMenu}>Cerrar</Button>
        </DialogActions>
      </Dialog>
  );
};

export default DialogModal;



